export enum UpdateRolesSteps {
  Details = "details",
  Result = "result",
}
